import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { shades } from '../../../theme';

const ComingSoon = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
			  display: 'flex',
			  flexDirection: 'column',
			  alignItems: 'center',
			  justifyContent: 'center',
			  height: '50rem',
			  textAlign: 'center',
			  px: 3,
			  backgroundColor: '#121212',
			  color: 'white'
      }}
    >
      <Typography
        variant='h2'
        component='h1'
        gutterBottom
        sx={{ color: 'white' }}
      >
        Coming Soon
      </Typography>
      <Typography variant='body1' paragraph sx={{ color: 'white' }}>
        We are working hard to bring this service to you. Stay tuned!
      </Typography>
      <Button
        variant='contained'
        color='primary'
        onClick={() => navigate('/app/products')}
        sx={{
				  bgcolor: 'primary.main',
				  color: 'white'
        }}
      >
        Continue Shopping
      </Button>
    </Box>
  );
};

export default ComingSoon;
